import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ScrollTopModule } from '@app/layout/scroll-top/modules/scroll-top.module';
import { ButtonModule } from '@components/button/modules/button.module';
import { AppDialogModule } from '@components/dialog/modules/app-dialog.module';
import { PanelTitleModule } from '@components/panel-title/panel-title.module';
import { SelectionListModule } from '@components/selection-list/modules/selection-list.module';
import { getTuiLang } from '@constants/factoryConstants';
import { TuiDestroyService } from '@taiga-ui/cdk';
import { TuiAlertModule, TuiRootModule } from '@taiga-ui/core';
import { TUI_LANGUAGE } from '@taiga-ui/i18n';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './core/app.routing.module';
import { GlobalModule } from './core/global.module';
import { MainModule } from './core/main.module';
import { BreadcrumbsModule } from './layout/breadcrumbs/modules/breadcrumbs.module';
import { FooterModule } from './layout/footer/modules/footer.module';
import { HeaderModule } from './layout/header/header.module';
import { SideMenuModule } from './layout/side-menu/modules/side-menu.module';
import { TableModule } from './modules/table/table.module';

@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserAnimationsModule,
        AppRoutingModule,
        MainModule,
        GlobalModule,
        BreadcrumbsModule,
        FooterModule,
        HeaderModule,
        TableModule,
        SideMenuModule,
        ScrollTopModule,
        PanelTitleModule,
        TuiRootModule,
        TuiAlertModule,
        AppDialogModule,
        SelectionListModule,
        ButtonModule,
    ],
    bootstrap: [AppComponent],
    providers: [
        {
            provide: TUI_LANGUAGE,
            useValue: getTuiLang(),
        },
        TuiDestroyService,
    ],
})
export class AppModule {}
